export function toNumber(v) {
  if (v == null) return null;
  const n = Number(String(v).replace(",", "."));
  return Number.isFinite(n) ? n : null;
}

export function asString(v) {
  if (v == null) return "";
  return String(v);
}

export function normalizeColumnName(name) {
  if (name == null) return "";
  let s = String(name);
  // Remove BOM that can stick to the first header
  s = s.replace(/^\uFEFF/, "");
  s = s.trim().toLowerCase();
  // Strip common diacritics (best-effort) so "géométrie" and "geometrie" match.
  try {
    s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  } catch {
    // ignore if normalize() isn't available (very old runtimes)
  }
  // Remove unit suffixes like " (m)" or " (m²)"
  s = s.replace(/\s*\([^)]*\)\s*$/g, "");
  // Replace degree/numero symbols used in headers (e.g. "N° Point")
  s = s.replace(/[°º№]/g, "");
  // Normalize separators/spaces
  s = s.replace(/[\s\-]+/g, "_");
  // Make it robust to encoding artifacts by collapsing everything non-alnum to underscores.
  s = s.replace(/[^a-z0-9_]+/g, "_");
  s = s.replace(/_+/g, "_").replace(/^_+|_+$/g, "");
  return s;
}

export function splitNonEmptyLines(text) {
  return String(text || "")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .split("\n")
    .filter((l) => l.trim() !== "");
}

export function samePoint(a, b) {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length >= 2 &&
    b.length >= 2 &&
    a[0] === b[0] &&
    a[1] === b[1]
  );
}

